var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 113,
    viewBox: "0 0 74 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46545 18.0832L34.7859 36.9618V0.0336914L27.9381 3.95633V25.3219L16.7094 18.3933L23.1797 14.3021V6.69948L3.46545 18.0832Z",
    fill: "#F4E096"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2649 63.6723L39.2073 44.915V81.6005L45.9944 77.6846V56.5549L57.2231 63.4768L50.7528 67.5679V74.9347L70.2649 63.6723Z",
    fill: "#F4E096"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8055 14.7739L45.8057 25.4365V11.9903L53.0376 16.3039L60.0134 12.0106L39.2073 0V36.982L70.8647 18.2787L64.8055 14.7739Z",
    fill: "#F4E096"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44362 66.9681L28.1874 56.4538V69.9067L20.9554 65.5931L14.229 69.7315L34.7857 81.6005V44.915L3.37769 63.4701L9.44362 66.9681Z",
    fill: "#F4E096"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4393 22.8755V46.1148L66.9622 42.3404V33.9559L59.6494 38.0808L54.7899 40.8172L66.9622 47.9076L73.4393 51.6819V59.3183L48.1309 44.5713L41.6538 40.797L45.6371 38.5526L48.3129 37.0428L53.1656 34.3064L66.9622 26.5285L73.4393 22.8755Z",
    fill: "#F4E096"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.560547 59.3183V36.079L7.03762 39.8534V48.2378L14.3504 44.113L19.2099 41.3766L7.03762 34.2862L0.560547 30.5118V22.8755L25.869 37.6225L32.346 41.3968L28.3628 43.6412L25.687 45.1509L20.8343 47.8874L7.03762 55.6652L0.560547 59.3183Z",
    fill: "#F4E096"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3189 93.6999H18.562V98.0835H22.448V93.6999H24.6833V105.318H22.448V100.224H18.562V105.318H16.3189V93.6999ZM27.6685 93.6999H34.0109V95.864H29.8643V97.965H34.0109V100.09H29.8643V103.146H34.0109V105.318H27.6685V93.6999ZM35.5192 93.6999H37.6991L39.3736 101.116L41.4508 93.6999H43.2911L45.3921 101.116L47.0508 93.6999H49.2307L46.6164 105.318H44.4917L42.3512 97.807L40.2503 105.318H38.1493L35.5192 93.6999ZM51.2998 93.6999H57.6421V95.864H53.4955V97.965H57.6421V100.09H53.4955V103.146H57.6421V105.318H51.2998V93.6999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1a9b8b1b2d1986e9c02f7506949fb285.svg";
export { ForwardRef as ReactComponent };